/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team saved automatically`)
};

const es_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo guardado automáticamente`)
};

const de_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team wird automatisch gespeichert`)
};

const nl_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team wordt automatisch opgeslagen`)
};

const fr_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe sauvegardée automatiquement`)
};

const it_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadra salvata automaticamente`)
};

const pt_br2_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time salvo automaticamente`)
};

const pt_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipa guardada automaticamente`)
};

const ja_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームは自動保存されます`)
};

const zh_f1_myteam_saved = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阵容已自动保存`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_saved = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_saved(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_saved", locale)
	if (locale === "en") return en_f1_myteam_saved(inputs)
	if (locale === "es") return es_f1_myteam_saved(inputs)
	if (locale === "de") return de_f1_myteam_saved(inputs)
	if (locale === "nl") return nl_f1_myteam_saved(inputs)
	if (locale === "fr") return fr_f1_myteam_saved(inputs)
	if (locale === "it") return it_f1_myteam_saved(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_saved(inputs)
	if (locale === "pt") return pt_f1_myteam_saved(inputs)
	if (locale === "ja") return ja_f1_myteam_saved(inputs)
	return zh_f1_myteam_saved(inputs)
};